import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DataFetch from "./DataFetch";
import SuccessMsg from "../../Extra/SuccessMsg";
import FailedMsg from "../../Extra/FailedMsg";
import Loading from "../../Extra/Loading";
import {
  getModifiedObjects,
  getUpdatedObjects,
  minutesToHHMM,
  secondsToTime,
  timeToMinutes,
  timeToSeconds,
} from "../../Utilitie";
import { MdDelete } from "react-icons/md";
import DownloadExcel from "../../Extra/DownloadExcel";
import UpdateFilters from "./UpdateFilters";
import DownloadExcelFromData from "../../Extra/DownloadExcelFromData";
import { columnWidths, tableHeadForExcel } from "./UpdateHalper";
import { IoMdAlert } from "react-icons/io";
import { useGlobalContext } from "../../Context/GlobalContext";
import { fetchGrantedNotOptions, fetchAvailedNotOptions } from "./UpdateHalper";
import DownloadExcelFromTable from "../../Extra/DownloadExcelFromTable";
import { FiEdit3 } from "react-icons/fi";
const grantedNotOptions = fetchGrantedNotOptions();
const opState = {
  Section: false,
  From_Station: false,
  To_Station: false,
  Department: false,
  Type: false,
  "Block Type": false,
  "Granted/Not": false,
  "Availed/Not": false,
  Burst: false,
  Corridore: false,
  Direction: false,
  Rolling_Block: false,
};

const Update = ({ selectedDate, setDataChanged }) => {
  const { userData } = useGlobalContext();
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const urlPrefix2 = process.env.REACT_APP_URL_INSPECTION_PREFIX;
  const [entryCount, setEntryCount] = useState(1);
  const [entries, setEntries] = useState([]);
  const [reportDate, setReportDate] = useState(selectedDate?.date || "");
  const [stations, setStations] = useState([]);
  const [machineData, setMachineData] = useState([]);
  const [result, setResult] = useState(null);
  const [show, setShow] = useState(false);
  const [fetchedRecords, setFetchedRecords] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSno, setSelectedSno] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [error, setError] = useState(false);
  const [dynamicOptions, setDynamicOptions] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [openStates, setOpenStates] = useState({ opState });
  const [grantedNotOptions, setGrantedNotOptions] = useState([
    {
      Sno: 35,
      table_option_for_insertion: "Loading",
      tabel_path: "B_Granted_Not",
    },
  ]);
  const [availedNotOptions, setAvailedNotOptions] = useState([
    {
      Sno: 35,
      table_option_for_insertion: "Loading",
      tabel_path: "B_Granted_Not",
    },
  ]);
  useEffect(() => {
    const loadData = async () => {
      const data = await fetchGrantedNotOptions();
      setGrantedNotOptions(data);
      const data2 = await fetchAvailedNotOptions();
      setAvailedNotOptions(data2);
    };
    loadData();
  }, []);
  const tableRef = useRef();
  const tableRef2 = useRef();
  const cellRefs = useRef({});

  const defaultSelections = {
    section: "",
    Direction: "",
    From_Station: "",
    To_Station: "",
    Section_Yard: "",
    Corridore: "",
    Department: "",
    Type: "",
    Asset: "",
    Block_Type: "",
    No_Of_Demand_By_Engg: "0",
    Engg_Demand: "00:00",
    No_Of_Demand_Agreed_GIVEN: "0",
    Agreed_Demand: "00:00",
    GrantedFrom: "00:00",
    GrantedTo: "00:00",
    Granted_Duration: "00:00",
    Availed_From: "00:00",
    Availed_To: "00:00",
    Availed: "00:00",
    Burst: "NOT BURST",
    Burst_Duration: "00:00",
    Actual_Output_in_Meter: "",
    Actual_Output: "",
    Granted_Not: "NOT GRANTED",
    Availed_Not: "NOT AVAILED",
    Remarks: "",
    Reason: "",
    Rolling_Block: "",
  };

  const fetchData2 = async (date) => {
    setLoading2(true);
    const url = `${urlPrefixBlock}getblockdatabydate?end=${date.date}`;

    try {
      const response = await axios.get(url);
      const result = response.data;

      if (result.status === "ok") {
        const raw = result.currentDate.data;
        const flattened = raw.flatMap((item) =>
          item.children.flatMap((dept) =>
            dept.children.flatMap((directionBlock) =>
              directionBlock.data.map((block) => ({
                ...block,
                reportDate: result.currentDate.date,
                section: block.section,
              })),
            ),
          ),
        );
        const sortedData = flattened.sort((a, b) => a.Sno - b.Sno);
        setFetchedRecords(sortedData);
      }
      setLoading2(false);
    } catch (error) {
      console.error("Axios fetch error:", error);
      setError(true);
      setLoading2(false);
    }
  };

  useEffect(() => {
    if (selectedDate) {
      fetchData2(selectedDate);
    }
  }, [selectedDate]);

  const [selectedSections, setSelectedSections] = useState([]);

  const filteredData = entries.filter((item) =>
    selectedSections.length === 0
      ? true
      : selectedSections.includes(item.selections.section),
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlPrefixBlock}getstationcode`);
      if (response.data.status === "ok") {
        const fetchedData = response.data.data;

        const uniqueByName = Array.from(
          new Map(fetchedData.map((obj) => [obj.id, obj])).values(),
        );

        uniqueByName.sort((a, b) => a.station.localeCompare(b.station));

        setStations(uniqueByName);
      }
    } catch (err) {
      console.error("Failed to fetch data:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchMachineData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlPrefixBlock}getmachinetype`);
      if (response.data.status === "ok") {
        setMachineData(response.data.machineTypes);
      }
    } catch (err) {
      console.error("Failed to fetch machine types:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMachineData();
  }, []);

  useEffect(() => {
    if (records && records.length > 0 && machineData.length > 0) {
      const initialEntries = records.map((record) => {
        let derivedAsset = "";
        let derivedType = record.Type || "";
        let derivedDepartment = record.Department || "";

        if (record.Block_Type) {
          for (const dept of machineData) {
            for (const type of dept.children || []) {
              for (const asset of type.children || []) {
                if (
                  asset.data.some(
                    (item) => item.ASSET_DISCRIPTION === record.Block_Type,
                  )
                ) {
                  derivedAsset = asset.ASSET;
                  derivedType = type.TYPE;
                  derivedDepartment = dept.DEPARTMENT;
                  break;
                }
              }
              if (derivedAsset) break;
            }
            if (derivedAsset) break;
          }
        }

        // Determine Reason options based on Granted_Duration and Availed
        const reasonOptions =
          record.Granted_Duration === "00:00"
            ? grantedNotOptions.map((obj) => obj.table_option_for_insertion)
            : record.Availed === "00:00"
              ? availedNotOptions.map((obj) => obj.table_option_for_insertion)
              : [];

        return {
          Sno: record.Sno || null,
          selections: {
            ...defaultSelections,
            section: record.section || "",
            Direction: record.Direction || "",
            From_Station: record.From_Station || "",
            To_Station: record.To_Station || "",
            Section_Yard: record.Section_Yard || "",
            Corridore: record.Corridore || "",
            Department: record.Department,
            Type: derivedType,
            Asset: derivedAsset,
            Block_Type: record.Block_Type || "",
            No_Of_Demand_By_Engg: record.No_Of_Demand_By_Engg || "0",
            Engg_Demand: record.Engg_Demand || "00:00",
            No_Of_Demand_Agreed_GIVEN: record.No_Of_Demand_Agreed_GIVEN || "0",
            Agreed_Demand: record.Agreed_Demand || "00:00",
            GrantedFrom: record.GrantedFrom || "00:00",
            GrantedTo: record.GrantedTo || "00:00",
            Granted_Duration: record.Granted_Duration || "00:00",
            Availed_From: record.Availed_From || "00:00",
            Availed_To: record.Availed_To || "00:00",
            Availed: record.Availed || "00:00",
            Burst: record.Burst || "",
            Burst_Duration: secondsToTime(
              timeToSeconds(record.Availed) -
                timeToSeconds(record.Granted_Duration),
            ).slice(0, 5),
            Actual_Output: record.Actual_Output || "",
            Remarks: record.Remarks || "",
            Granted_Not: record.Granted_Not || "",
            Availed_Not: record.Availed_Not || "",
            Actual_Output_in_Meter: record.Actual_Output_in_Meter || "",
            Reason: record.Reason || "",
            Rolling_Block: record.Rolling_Block || "",
          },
        };
      });

      setEntries(initialEntries);
      setEntryCount(records.length);

      const newDynamicOptions = records.map((record) => {
        const options = { Type: [], Asset: [], Block_Type: [], Reason: [] };
        if (record.Department) {
          const selectedDept = machineData.find(
            (dept) => dept.DEPARTMENT === record.Department,
          );
          if (selectedDept) {
            options.Type =
              selectedDept.children.map((child) => child.TYPE) || [];
          }
        }
        if (record.Type) {
          const dept = machineData.find(
            (dept) => dept.DEPARTMENT === record.Department,
          );
          const selectedType = dept?.children.find(
            (child) => child.TYPE === record.Type,
          );
          if (selectedType) {
            options.Asset =
              selectedType.children.map((asset) => asset.ASSET) || [];
          }
        }
        if (record.Block_Type) {
          const dept = machineData.find(
            (dept) => dept.DEPARTMENT === record.Department,
          );
          const type = dept?.children.find(
            (child) => child.TYPE === record.Type,
          );
          const selectedAsset = type?.children.find((asset) =>
            asset.data.some(
              (item) => item.ASSET_DISCRIPTION === record.Block_Type,
            ),
          );
          if (selectedAsset) {
            options.Block_Type =
              selectedAsset.data.map((item) => item.ASSET_DISCRIPTION) || [];
          }
        }
        // Set Reason options based on Granted_Duration and Availed
        options.Reason =
          record.Granted_Duration === "00:00"
            ? grantedNotOptions.map((obj) => obj.table_option_for_insertion)
            : record.Availed === "00:00"
              ? availedNotOptions.map((obj) => obj.table_option_for_insertion)
              : [];
        return options;
      });

      setDynamicOptions(newDynamicOptions);
    } else {
      setEntries(
        Array.from({ length: entryCount }, () => ({
          Sno: null,
          selections: { ...defaultSelections },
        })),
      );
      setDynamicOptions(
        Array.from({ length: entryCount }, () => ({
          Type: [],
          Asset: [],
          Block_Type: [],
          Reason: [],
        })),
      );
    }
  }, [records, machineData, entryCount]);

  useEffect(() => {
    setEntries((prev) =>
      entryCount > prev.length
        ? [
            ...prev,
            ...Array.from({ length: entryCount - prev.length }, () => ({
              Sno: null,
              selections: { ...defaultSelections },
            })),
          ]
        : prev.slice(0, entryCount),
    );
    setDynamicOptions((prev) =>
      entryCount > prev.length
        ? [
            ...prev,
            ...Array.from({ length: entryCount - prev.length }, () => ({
              Type: [],
              Asset: [],
              Block_Type: [],
              Reason: [],
            })),
          ]
        : prev.slice(0, entryCount),
    );
  }, [entryCount]);

  useEffect(() => {
    setReportDate(selectedDate?.date || "");
  }, [selectedDate]);

  const keys = [
    "Direction",
    "From_Station",
    "To_Station",
    "Section_Yard",
    "Corridore",
    "Department",
    "Type",
    "Asset",
    "Block_Type",
    "No_Of_Demand_By_Engg",
    "Engg_Demand",
    "No_Of_Demand_Agreed_GIVEN",
    "Agreed_Demand",
    "GrantedFrom",
    "GrantedTo",
    "Granted_Duration",
    "Availed_From",
    "Availed_To",
    "Availed",
    "Burst",
    "Burst_Duration",
    "Actual_Output_in_Meter",
    "Actual_Output",
    "Granted_Not",
    "Availed_Not",
    "Remarks",
    "Reason",
    "Rolling_Block",
  ];

  const uniqueSection = Array.from(
    new Map(stations.map((obj) => [obj.section, obj.section])).values(),
  );

  const staticOptions = {
    section: uniqueSection,
    From_Station: [],
    To_Station: [],
    Department: machineData.map((dept) => dept.DEPARTMENT),
    Section_Yard: [],
    Direction: [
      "BOTH",
      "CHORD LINE",
      "DOWN",
      "SINGLE LINE",
      "THIRD",
      "UP",
      "UP GS",
      "UDL",
    ],
    Corridore: ["Corridor", "Non-Corridor", "****"],
    No_Of_Demand_By_Engg: [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
    ],
    No_Of_Demand_Agreed_GIVEN: [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
    ],
    Agreed_Demand: [],
    GrantedFrom: [],
    GrantedTo: [],
    Granted_Duration: [],
    Availed_From: [],
    Availed_To: [],
    Availed: [],
    Burst: [],
    Burst_Duration: [],
    Actual_Output: [],
    Actual_Output_in_Meter: [],
    Granted_Not: [],
    Availed_Not: [],
    Remarks: [],
    Reason: [],
    Rolling_Block: ["Rolling Block", "Non Rolling Block", "--"],
  };

  const handleChange = (formIndex, key, value) => {
    const updatedEntries = [...entries];
    updatedEntries[formIndex].selections[key] = value;

    const updatedDynamicOptions = [...dynamicOptions];

    if (key === "section") {
      updatedEntries[formIndex].selections.From_Station = "";
      updatedEntries[formIndex].selections.To_Station = "";
    }

    if (key === "Department") {
      const selectedDept = machineData.find(
        (dept) => dept.DEPARTMENT === value,
      );
      updatedDynamicOptions[formIndex] = {
        Type: selectedDept?.children.map((child) => child.TYPE) || [],
        Asset: [],
        Block_Type: [],
        Reason: updatedDynamicOptions[formIndex].Reason || [],
      };
      updatedEntries[formIndex].selections.Type = "";
      updatedEntries[formIndex].selections.Asset = "";
      updatedEntries[formIndex].selections.Block_Type = "";
    }

    if (key === "Type") {
      const selectedDept = updatedEntries[formIndex].selections.Department;
      const dept = machineData.find((dept) => dept.DEPARTMENT === selectedDept);
      const selectedType = dept?.children.find((child) => child.TYPE === value);
      updatedDynamicOptions[formIndex] = {
        ...updatedDynamicOptions[formIndex],
        Asset: selectedType?.children.map((asset) => asset.ASSET) || [],
        Block_Type: [],
      };
      updatedEntries[formIndex].selections.Asset = "";
      updatedEntries[formIndex].selections.Block_Type = "";
    }

    if (key === "Asset") {
      const selectedDept = updatedEntries[formIndex].selections.Department;
      const selectedType = updatedEntries[formIndex].selections.Type;
      const dept = machineData.find((dept) => dept.DEPARTMENT === selectedDept);
      const type = dept?.children.find((child) => child.TYPE === selectedType);
      const selectedAsset = type?.children.find(
        (asset) => asset.ASSET === value,
      );
      updatedDynamicOptions[formIndex] = {
        ...updatedDynamicOptions[formIndex],
        Block_Type:
          selectedAsset?.data.map((item) => item.ASSET_DISCRIPTION) || [],
      };
      updatedEntries[formIndex].selections.Block_Type = "";
    }

    if (key === "GrantedFrom") {
      updatedEntries[formIndex].selections.Availed_From = value;
    }
    if (key === "GrantedTo") {
      updatedEntries[formIndex].selections.Availed_To = value;
    }

    if (
      updatedEntries[formIndex].selections.GrantedFrom &&
      updatedEntries[formIndex].selections.GrantedTo
    ) {
      let a = timeToSeconds(updatedEntries[formIndex].selections.GrantedFrom);
      let b = timeToSeconds(updatedEntries[formIndex].selections.GrantedTo);
      let c;
      if (a > b) {
        c = minutesToHHMM((b - a + 86400) / 60);
      } else {
        c = minutesToHHMM((b - a) / 60);
      }
      updatedEntries[formIndex].selections.Granted_Duration = c;
    } else {
      updatedEntries[formIndex].selections.Granted_Duration = "00:00";
    }

    if (
      updatedEntries[formIndex].selections.Availed_From &&
      updatedEntries[formIndex].selections.Availed_To
    ) {
      let a = timeToSeconds(updatedEntries[formIndex].selections.Availed_From);
      let b = timeToSeconds(updatedEntries[formIndex].selections.Availed_To);
      let c;
      if (a > b) {
        c = minutesToHHMM((b - a + 86400) / 60);
      } else {
        c = minutesToHHMM((b - a) / 60);
      }
      updatedEntries[formIndex].selections.Availed = c;
    } else {
      updatedEntries[formIndex].selections.Availed = "00:00";
    }

    if (
      updatedEntries[formIndex].selections.Availed &&
      updatedEntries[formIndex].selections.Granted_Duration
    ) {
      updatedEntries[formIndex].selections.Burst =
        updatedEntries[formIndex].selections.Availed <=
        updatedEntries[formIndex].selections.Granted_Duration
          ? "NOT BURST"
          : "BURST";
      updatedEntries[formIndex].selections.Burst_Duration = secondsToTime(
        timeToSeconds(updatedEntries[formIndex].selections.Availed) -
          timeToSeconds(updatedEntries[formIndex].selections.Granted_Duration),
      ).slice(0, 5);
    } else {
      updatedEntries[formIndex].selections.Burst = "NOT BURST";
    }

    if (updatedEntries[formIndex].selections.Granted_Duration) {
      // const { GrantedFrom, GrantedTo, Granted_Duration } =
      //   updatedEntries[formIndex].selections;
      // updatedEntries[formIndex].selections.Granted_Not =
      //   !GrantedFrom ||
      //   GrantedFrom === "00:00" ||
      //   !GrantedTo ||
      //   GrantedTo === "00:00" ||
      //   !Granted_Duration ||
      //   Granted_Duration === "00:00"
      //     ? "NOT GRANTED"
      //     : "GRANTED";
      updatedEntries[formIndex].selections.Granted_Not =
        updatedEntries[formIndex].selections.Granted_Duration === "00:00"
          ? "NOT GRANTED"
          : "GRANTED";
    }

    if (updatedEntries[formIndex].selections.Availed) {
      updatedEntries[formIndex].selections.Availed_Not =
        updatedEntries[formIndex].selections.Availed === "00:00"
          ? "NOT AVAILED"
          : "AVAILED";
    }

    // Update Reason options based on Granted_Duration and Availed
    if (
      key === "GrantedFrom" ||
      key === "GrantedTo" ||
      key === "Availed_From" ||
      key === "Availed_To"
    ) {
      const reasonOptions =
        updatedEntries[formIndex].selections.Granted_Duration === "00:00"
          ? grantedNotOptions.map((obj) => obj.table_option_for_insertion)
          : updatedEntries[formIndex].selections.Availed === "00:00"
            ? availedNotOptions.map((obj) => obj.table_option_for_insertion)
            : [];
      updatedDynamicOptions[formIndex] = {
        ...updatedDynamicOptions[formIndex],
        Reason: reasonOptions,
      };
      updatedEntries[formIndex].selections.Reason = reasonOptions.includes(
        updatedEntries[formIndex].selections.Reason,
      )
        ? updatedEntries[formIndex].selections.Reason
        : "";
    }

    if (key === "No_Of_Demand_By_Engg" || key === "No_Of_Demand_Agreed_GIVEN") {
      if (
        updatedEntries[formIndex].selections.No_Of_Demand_By_Engg == 0 &&
        updatedEntries[formIndex].selections.No_Of_Demand_Agreed_GIVEN != 0
      ) {
        updatedEntries[formIndex].selections.Rolling_Block =
          "Non Rolling Block";
      } else {
        updatedEntries[formIndex].selections.Rolling_Block = "Rolling Block";
      }
    }
    if (key === "From_Station" || key === "To_Station") {
      if (
        updatedEntries[formIndex].selections.From_Station &&
        updatedEntries[formIndex].selections.To_Station
      ) {
        updatedEntries[formIndex].selections.Section_Yard =
          updatedEntries[formIndex].selections.From_Station ===
          updatedEntries[formIndex].selections.To_Station
            ? "Yard"
            : "Section";
      } else {
        updatedEntries[formIndex].selections.Section_Yard = "";
      }
    }

    if (key === "Reason") {
      updatedEntries[formIndex].selections.Reason = value || "";
    }

    setEntries(updatedEntries);
    setDynamicOptions(updatedDynamicOptions);
  };

  const handleSubmit = async () => {
    const allData = entries.map((entry) => {
      const { Asset, ...selectionsWithoutAsset } = entry.selections;
      return {
        reportDate,
        Sno: entry.Sno || null,
        section: entry.selections.section || "",
        ...selectionsWithoutAsset,
      };
    });
    const dataToUpdateTemp = getModifiedObjects(fetchedRecords, allData);
    const dataToUpdate = dataToUpdateTemp.map((obj) => {
      return { ...obj, updated_by: userData.id };
    });

    try {
      const response = await fetch(`${urlPrefixBlock}updateblockdata`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToUpdate),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      const updatedSno = result.details.map((obj) => obj.Sno);

      setResult({
        status: "ok",
        message: `Sno -${result.details.map(
          (obj) => `${obj.Sno},`,
        )} are updated successfully`,
      });
      setDataChanged((prev) => !prev);
      fetchData2(selectedDate);
      setShow(true);
    } catch (err) {
      console.error("Error submitting data:", err);
      setResult({
        status: "error",
        message: "Failed to submit data or there is nothing to update",
      });
      setShow(true);
    }
  };

  const clsStyle = "form-control form-control-sm";
  const inputStyle = {
    width: "100%",
    fontSize: "0.8rem",
    padding: "4px 8px",
  };

  const handleKeyDown = (e, rowIndex, colIndex, head) => {
    const rows = filteredData.length;
    const cols = keys.length + 3;
    let newRow = rowIndex;
    let newCol = colIndex;
    let jumpF =
      head === "To_Station" || head === "Availed"
        ? 2
        : head === "Actual_Output"
          ? 3
          : 1;
    let jumpB =
      head === "Actual_Output_in_Meter" || head === "Corridore"
        ? 2
        : head === "Remarks"
          ? 3
          : 1;
    switch (e.key) {
      case "ArrowUp":
        e.preventDefault();
        newRow = Math.max(0, rowIndex - 1);
        break;
      case "ArrowDown":
      case "Enter":
        e.preventDefault();
        newRow = Math.min(rows - 1, rowIndex + 1);
        break;
      case "ArrowLeft":
        e.preventDefault();
        newCol = Math.max(2, colIndex - jumpB);
        break;
      case "ArrowRight":
        e.preventDefault();
        newCol = Math.min(cols - 2, colIndex + jumpF);
        break;
      default:
        return;
    }

    const key = `${newRow}-${newCol}`;
    const element = cellRefs.current[key];
    if (element) {
      element.focus();
      if (element.tagName === "SELECT") {
        element.click();
      }
    }
  };

  const renderAllOption = (key, formIndex, entry, colIndex) => {
    const activeDepartment = entries[formIndex]?.selections.Department || "";
    const activeType = entries[formIndex]?.selections.Type || "";
    const activeAsset = entries[formIndex]?.selections.Asset || "";
    const gReason = grantedNotOptions.map(
      (obj) => obj.table_option_for_insertion,
    );
    const aReason = availedNotOptions.map(
      (obj) => obj.table_option_for_insertion,
    );
    const selectedSection = entries[formIndex]?.selections.section || "";
    const rowOptions = dynamicOptions[formIndex] || {
      Type: [],
      Asset: [],
      Block_Type: [],
      Reason: [],
    };
    const allOptions = {
      ...staticOptions,
      Type: rowOptions.Type,
      Asset: rowOptions.Asset,
      Block_Type: rowOptions.Block_Type,
      // Reason: rowOptions.Reason,
      Reason:
        entry.selections.Granted_Duration === "00:00:00" ||
        entry.selections.Granted_Duration === "00:00"
          ? [...gReason]
          : entry.selections.Availed === "00:00:00" ||
              entry.selections.Availed === "00:00"
            ? [...aReason]
            : ["disable"],

      From_Station: selectedSection
        ? stations
            .filter((station) => station.section === selectedSection)
            .map((station) => station.station)
        : stations.map((station) => station.station),
      To_Station: selectedSection
        ? stations
            .filter((station) => station.section === selectedSection)
            .map((station) => station.station)
        : stations.map((station) => station.station),
    };
    if (key === "Reason") {
      return (
        <select
          className="form-select form-select-sm"
          value={entry.selections[key] || ""}
          onChange={(e) => handleChange(formIndex, key, e.target.value)}
          onKeyDown={(e) => handleKeyDown(e, formIndex, colIndex, key)}
          ref={(el) => (cellRefs.current[`${formIndex}-${colIndex}`] = el)}
          style={{
            width: columnWidths[key],
          }}
          disabled={
            allOptions?.Reason?.length === 1 &&
            allOptions?.Reason[0] === "disable"
          }
        >
          <option value="">Select</option>
          {allOptions.Reason.map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      );
    }

    return (
      <select
        className="form-select form-select-sm"
        value={entry.selections[key] || ""}
        onChange={(e) => handleChange(formIndex, key, e.target.value)}
        onKeyDown={(e) => handleKeyDown(e, formIndex, colIndex, key)}
        ref={(el) => (cellRefs.current[`${formIndex}-${colIndex}`] = el)}
        style={{
          width:
            key === "section" ? columnWidths["Section"] : columnWidths[key],
        }}
      >
        <option value="">Select</option>
        {allOptions[key]
          .sort((a, b) => a.localeCompare(b))
          .map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
      </select>
    );
  };

  const removeBySno = (arr, targetSno) => {
    const index = arr.findIndex((obj) => obj.Sno === targetSno);
    if (index !== -1) {
      arr.splice(index, 1);
    }
  };

  const handleDelete = async (Sno) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this entry?",
    );
    if (!confirmed) return;

    setLoading(true);
    let result = {};

    try {
      const response = await fetch(`${urlPrefixBlock}deleteblockdata/${Sno}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      result = await response.json();

      if (!result.status === "ok") {
        throw new Error(`HTTP error! status: ${result.message}`);
      }

      if (result.status === "ok") {
        setResult({ status: "ok", message: result.message });
        setShow(true);
        fetchData2(selectedDate);
        setEntries((prev) => {
          const newEntries = [...prev];
          removeBySno(newEntries, Sno);
          return newEntries;
        });

        setDataChanged((prev) => !prev);
      }

      if (result.status === "Warning") {
        setResult({ status: "Warning", message: result.message });
        setShow(true);
      }

      setLoading(false);
    } catch (err) {
      console.error("Error submitting data:", err);
      setResult({ status: "error", message: result?.message || err.message });
      setShow(true);
      setLoading(false);
    }
  };

  return (
    <div
      className="m-1"
      onClick={() => {
        setOpenStates(opState);
      }}
    >
      <div className="mb-3">
        <div
          className="card border-0 shadow-sm mb-3"
          style={{ borderRadius: "12px", overflow: "hidden" }}
        >
          <div
            className="card-body p-3"
            style={{
              background:
                "linear-gradient(110deg, #07a714 0%, #438d30 65%, #337da8 100%)",
            }}
          >
            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-3">
              {/* Header Title */}
              <div className="d-flex align-items-center gap-2">
                <div
                  className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
                  style={{
                    width: "42px",
                    height: "42px",
                    background: "rgba(255,255,255,0.16)",
                    color: "#fff",
                    fontSize: "21px",
                  }}
                >
                  <FiEdit3 />
                </div>

                <div>
                  <h6 className="text-white fw-bold mb-1">Update Block Data</h6>
                  <div className="text-white-50 small">
                    Report Date:{" "}
                    <span className="text-white fw-semibold">{reportDate}</span>
                  </div>
                </div>
              </div>

              {/* Entry Count */}
              <div
                className="d-flex align-items-center justify-content-between gap-3 rounded-3 px-3 py-2"
                style={{ background: "rgba(255,255,255,0.12)" }}
              >
                <label
                  htmlFor="updateEntryCount"
                  className="text-white small fw-semibold mb-0 text-nowrap"
                >
                  Number of Entries
                </label>

                <input
                  id="updateEntryCount"
                  type="number"
                  min="1"
                  max="23"
                  className="form-control form-control-sm fw-semibold"
                  style={{
                    width: "75px",
                    background: "#fff",
                    color: "#063b87",
                    border: "none",
                    borderRadius: "7px",
                  }}
                  value={entryCount}
                  disabled
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sticky-controller">
        <UpdateFilters
          data={fetchedRecords}
          openStates={openStates}
          setRecords={setRecords}
          setOpenStates={setOpenStates}
        />
      </div>
      {loading && <Loading />}
      {loading2 ? (
        <Loading />
      ) : (
        <div
          className="table-responsive"
          ref={tableRef}
          style={{ maxHeight: "800px", overflow: "auto" }}
        >
          <table
            ref={tableRef2}
            className="table table-bordered table-striped mb-4 excel-table fixed-header-table"
            style={{
              borderCollapse: "collapse",
            }}
          >
            <thead className="table-dark sticky-header">
              <tr className="">
                <th
                  rowSpan={2}
                  className="p-1"
                  style={{ width: columnWidths.Id }}
                >
                  Id
                </th>
                <th
                  rowSpan={2}
                  className="sticky-col"
                  style={{ width: columnWidths.Date }}
                >
                  Date
                </th>
                <th rowSpan={2} style={{ width: "100px" }}>
                  Section
                </th>
                {keys.map((key) => {
                  if (key === "No_Of_Demand_Agreed_GIVEN") {
                    return (
                      <th
                        key={key}
                        className="text-wrap text-center"
                        colSpan={2}
                        style={{ width: columnWidths[key] }}
                      >
                        Demand Agreed
                      </th>
                    );
                  }
                  if (key === "No_Of_Demand_By_Engg") {
                    return (
                      <th
                        key={key}
                        className="text-wrap text-center"
                        colSpan={2}
                        style={{ width: columnWidths[key] }}
                      >
                        Demand by Engg
                      </th>
                    );
                  }
                  if (key === "GrantedFrom") {
                    return (
                      <th
                        key={key}
                        className="text-wrap text-center"
                        colSpan={3}
                        style={{ width: columnWidths[key] }}
                      >
                        Granted
                      </th>
                    );
                  }
                  if (key === "Availed_From") {
                    return (
                      <th
                        key={key}
                        className="text-wrap text-center"
                        colSpan={3}
                        style={{ width: columnWidths[key] }}
                      >
                        Availed
                      </th>
                    );
                  }
                  if (key === "Actual_Output") {
                    return (
                      <th
                        key={key}
                        className="text-wrap text-center"
                        colSpan={2}
                        style={{ width: columnWidths[key] }}
                      >
                        Actual Output
                      </th>
                    );
                  }
                  if (
                    [
                      "GrantedTo",
                      "Granted_Duration",
                      "Availed_To",
                      "Availed",
                      "Agreed_Demand",
                      "Engg_Demand",
                      "Actual_Output_in_Meter",
                    ].includes(key)
                  ) {
                    return null;
                  }
                  return (
                    <th
                      key={key}
                      className="text-wrap text-center"
                      rowSpan={2}
                      style={{ width: columnWidths[key] }}
                    >
                      {key === "Corridore"
                        ? "Corridor"
                        : key.replace(/_/g, " ")}
                    </th>
                  );
                })}
                <th rowSpan={2} style={{ width: columnWidths.Delete }}>
                  Delete
                </th>
              </tr>
              <tr>
                <th style={{ width: columnWidths.No_Of_Demand_By_Engg }}>
                  no.
                </th>
                <th style={{ width: columnWidths.Engg_Demand }}>hrs.</th>
                <th style={{ width: columnWidths.No_Of_Demand_Agreed_GIVEN }}>
                  no.
                </th>
                <th style={{ width: columnWidths.Agreed_Demand }}>hrs.</th>
                <th style={{ width: columnWidths.GrantedFrom }}>From</th>
                <th style={{ width: columnWidths.GrantedTo }}>To</th>
                <th style={{ width: columnWidths.Granted_Duration }}>
                  Duration
                </th>
                <th style={{ width: columnWidths.Availed_From }}>From</th>
                <th style={{ width: columnWidths.Availed_To }}>To</th>
                <th style={{ width: columnWidths.Availed }}>Duration</th>
                <th style={{ width: columnWidths.Actual_Output_in_Meter }}>
                  In Meters
                </th>
                <th style={{ width: columnWidths.Actual_Output }}>Remark</th>
              </tr>
            </thead>
            <tbody>
              {records.length > 0 &&
                filteredData
                  .filter((item) => {
                    const matchesDirection = selectedValues.Direction
                      ? item.selections.Direction?.toUpperCase() ===
                        selectedValues.Direction?.toUpperCase()
                      : true;
                    const matchesSectionYard = selectedValues.Section_Yard
                      ? item.selections.Section_Yard?.toUpperCase() ===
                        selectedValues.Section_Yard?.toUpperCase()
                      : true;
                    const matchesCorridor = selectedValues.Corridor
                      ? item.selections.Corridore?.toUpperCase() ===
                        selectedValues.Corridor?.toUpperCase()
                      : true;
                    const matchesDepartment = selectedValues.Department
                      ? item.selections.Department?.toUpperCase() ===
                        selectedValues.Department?.toUpperCase()
                      : true;
                    const matchesType = selectedValues.Type
                      ? item.selections.Type?.toUpperCase() ===
                        selectedValues.Type?.toUpperCase()
                      : true;

                    return (
                      matchesDirection &&
                      matchesSectionYard &&
                      matchesCorridor &&
                      matchesDepartment &&
                      matchesType
                    );
                  })
                  .map((entry, formIndex) => (
                    <tr
                      key={formIndex}
                      className={`${
                        selectedSno === entry.Sno ? "activeTr" : ""
                      } activeTableTr`}
                    >
                      <td
                        className={`p-1`}
                        style={{
                          background: "rgba(156, 160, 163, 0.71)",
                          cursor: "pointer",
                          width: columnWidths.Id,
                        }}
                        onClick={() => setSelectedSno(entry.Sno)}
                      >
                        {entry.Sno}
                      </td>
                      <td
                        className="sticky-col p-1"
                        onClick={() => setSelectedSno(entry.Sno)}
                        style={{
                          width: columnWidths.Date,
                          cursor: "pointer",
                          background: "rgba(203, 205, 206, 1)",
                        }}
                      >
                        {/* {reportDate} */}
                        {reportDate.slice(8, 10)}-{reportDate.slice(5, 7)}-
                        {reportDate.slice(0, 4)}
                      </td>
                      <td style={{ width: columnWidths.Section }}>
                        {renderAllOption("section", formIndex, entry, 2)}
                      </td>
                      {keys.map((key, colIndex) => {
                        const isInputField = [
                          "Actual_Output",
                          "Actual_Output_in_Meter",
                          "Burst_Duration",
                          "Remarks",
                          "Engg_Demand",
                          "Agreed_Demand",
                          "GrantedFrom",
                          "GrantedTo",
                          "Granted_Duration",
                          "Availed_From",
                          "Availed_To",
                          "Availed",
                        ].includes(key);

                        const inputType =
                          key === "Actual_Output_in_Meter"
                            ? "number"
                            : key === "Actual_Output" ||
                                key === "Remarks" ||
                                key === "Burst_Duration"
                              ? "text"
                              : "time";

                        return (
                          <td key={key} style={{ width: columnWidths[key] }}>
                            {key === "Section_Yard" ||
                            key === "Burst" ||
                            key === "Availed_Not" ||
                            key === "Granted_Not" ? (
                              <input
                                className="form-control form-control-sm"
                                style={{
                                  height: "26px",
                                  padding: "2px 6px",
                                  fontSize: "0.8rem",
                                  width: columnWidths[key],
                                }}
                                value={entry.selections[key] || ""}
                                disabled
                              />
                            ) : isInputField ? (
                              <input
                                type={inputType}
                                className="form-control form-control-sm"
                                style={{
                                  height: "26px",
                                  padding: "2px 6px",
                                  fontSize: "0.8rem",
                                  width: columnWidths[key],
                                }}
                                value={
                                  inputType === "time"
                                    ? entry.selections[key] || "00:00"
                                    : entry.selections[key] || ""
                                }
                                onChange={(e) =>
                                  handleChange(formIndex, key, e.target.value)
                                }
                                onKeyDown={(e) =>
                                  handleKeyDown(e, formIndex, colIndex + 3, key)
                                }
                                ref={(el) =>
                                  (cellRefs.current[
                                    `${formIndex}-${colIndex + 3}`
                                  ] = el)
                                }
                              />
                            ) : (
                              renderAllOption(
                                key,
                                formIndex,
                                entry,
                                colIndex + 3,
                              )
                            )}
                          </td>
                        );
                      })}
                      <td
                        onClick={() => handleDelete(entry.Sno, formIndex)}
                        style={{ width: columnWidths.Delete }}
                      >
                        <button className="btn btn-sm btn-outline-danger">
                          <MdDelete />
                        </button>
                      </td>
                    </tr>
                  ))}
            </tbody>
            <tfoot className="sticky-bottom" style={{ zIndex: 2 }}>
              <tr className="table-dark">
                <td className="" colSpan={12} rowSpan={2}>
                  Total
                </td>
                <td
                  rowSpan={2}
                  style={{ width: columnWidths.No_Of_Demand_By_Engg }}
                >
                  {records.reduce(
                    (sum, item) => sum + (item.No_Of_Demand_By_Engg || 0),
                    0,
                  )}
                </td>
                <td rowSpan={2} style={{ width: columnWidths.Engg_Demand }}>
                  {secondsToTime(
                    records.reduce(
                      (sum, item) =>
                        sum + (timeToSeconds(item.Engg_Demand) || 0),
                      0,
                    ),
                  ).slice(0, -3)}
                </td>
                <td
                  rowSpan={2}
                  style={{ width: columnWidths.No_Of_Demand_Agreed_GIVEN }}
                >
                  {records.reduce(
                    (sum, item) => sum + (item.No_Of_Demand_Agreed_GIVEN || 0),
                    0,
                  )}
                </td>
                <td rowSpan={2} style={{ width: columnWidths.Agreed_Demand }}>
                  {secondsToTime(
                    records.reduce(
                      (sum, item) =>
                        sum + (timeToSeconds(item.Agreed_Demand) || 0),
                      0,
                    ),
                  ).slice(0, -3)}
                </td>
                <td
                  rowSpan={2}
                  style={{ width: columnWidths.GrantedFrom }}
                ></td>
                <td rowSpan={2} style={{ width: columnWidths.GrantedTo }}></td>
                <td
                  rowSpan={2}
                  style={{ width: columnWidths.Granted_Duration }}
                >
                  {secondsToTime(
                    records.reduce(
                      (sum, item) =>
                        sum + (timeToSeconds(item.Granted_Duration) || 0),
                      0,
                    ),
                  ).slice(0, -3)}
                </td>
                <td
                  rowSpan={2}
                  style={{ width: columnWidths.Availed_From }}
                ></td>
                <td rowSpan={2} style={{ width: columnWidths.Availed_To }}></td>
                <td rowSpan={2} style={{ width: columnWidths.Availed }}>
                  {secondsToTime(
                    records.reduce(
                      (sum, item) => sum + (timeToSeconds(item.Availed) || 0),
                      0,
                    ),
                  ).slice(0, -3)}
                </td>
                <td style={{ width: columnWidths.Burst }}>
                  {" "}
                  {records.reduce(
                    (sum, item) =>
                      sum + (Number(item.Burst === "BURST" ? 1 : 0) || 0),
                    0,
                  )}
                </td>
                <td rowSpan={2} style={{ width: columnWidths.Burst_Duration }}>
                  Effective={" "}
                  {secondsToTime(
                    records &&
                      records.reduce((sum, item) => {
                        let a = timeToSeconds(item.Availed);
                        let b = timeToSeconds(item.Granted_Duration);

                        return sum + Number(a - b);
                      }, 0),
                  ).slice(0, -3)}{" "}
                  {/* {secondsToTime()} */}
                  <br />
                  Overall={" "}
                  {secondsToTime(
                    records &&
                      records.reduce((sum, item) => {
                        let a = timeToSeconds(item.Availed);
                        let b = timeToSeconds(item.Granted_Duration);

                        return sum + Number(a > b ? a - b : 0);
                      }, 0),
                  ).slice(0, -3)}{" "}
                </td>
                <td
                  rowSpan={2}
                  style={{ width: columnWidths.Actual_Output_in_Meter }}
                >
                  {records.reduce(
                    (sum, item) =>
                      sum + (Number(item.Actual_Output_in_Meter) || 0),
                    0,
                  )}
                </td>
                <td
                  rowSpan={2}
                  style={{ width: columnWidths.Actual_Output }}
                ></td>
                <td style={{ width: columnWidths.Granted_Not }}>
                  {" "}
                  {records.reduce(
                    (sum, item) =>
                      sum +
                      (Number(item.Granted_Not === "GRANTED" ? 1 : 0) || 0),
                    0,
                  )}
                </td>
                <td style={{ width: columnWidths.Availed_Not }}>
                  {" "}
                  {records.reduce(
                    (sum, item) =>
                      sum +
                      (Number(item.Availed_Not === "AVAILED" ? 1 : 0) || 0),
                    0,
                  )}
                </td>
                <td rowSpan={2} style={{ width: columnWidths.Remarks }}></td>
                <td
                  rowSpan={2}
                  style={{ width: columnWidths.Rolling_Block }}
                ></td>
                <td rowSpan={2} style={{ width: columnWidths.Delete }}></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
      {records.length === 0 && (
        <div className="alert alert-danger text-center" role="alert">
          <IoMdAlert /> No Data Found
        </div>
      )}
      {/* <DownloadExcelFromData
        data={records}
        columnOrder={tableHeadForExcel}
        fileName={`Block Data ${selectedDate.date}`}
      /> */}
      <DownloadExcelFromTable
        tableRef={tableRef2}
        fileName={`Block Data ${selectedDate.date}`}
      />
      {!loading2 && (
        <div className="text-center mt-4">
          <button
            className="btn btn-outline-success m-2 px-5"
            onClick={handleSubmit}
          >
            Update
          </button>

          <div className="p-3">
            {result && result.status === "ok" ? (
              <SuccessMsg
                head="Success"
                message={result.message}
                show={show}
                setShow={setShow}
              />
            ) : (
              result && (
                <FailedMsg
                  head="Failed"
                  message={result.message || "Failed to complete the task"}
                  show={show}
                  setShow={setShow}
                />
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Update;
